import React from 'react'
import { connect } from 'react-redux'

import Choices from '../../../../../../lib/IssueMapping/Choices'
import { ResuscitationQuestionnaire } from '../../../../../../lib/Questionnaires'
import {
  bindTargetMixin,
  CancelButton,
  QuestionRadioButtonInput,
  SaveButton,
  YesNoRadioOptions
} from '../../../../../shared/FormBuilder'
import IssueQueuer from '../../../../../shared/IssueQueuer'
import { narusGrey5 } from '../../../../../shared/NarusMaterial/colors'
import * as Actions from '../../../lib/new-actions'

export const RESUSCITATION_CATEGORY = 'Resuscitation Choice'

const style = {
  radioButton: {
    display: 'inline-block',
    width: '5rem'
  },
  radioGroup: {
    display: 'inline-block',
    verticalAlign: 'middle'
  },
  subHead: {
    color: `${narusGrey5}`
  },
  form: {
    marginTop: '15px',
    paddingTop: '15px'
  },
  saveButton: {
    marginLeft: '1rem'
  },
  marg: {
    marginTop: '1rem'
  }
}

class ResuscitationChoiceForm extends bindTargetMixin(React.Component) {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleCancel = this.handleCancel.bind(this)
  }

  componentDidMount () {
    this.setState({
      formChanged: false
    })
  }

  componentDidUpdate (prevProps, prevState) {
    const { resuscitation, resuscitationDocumentation } = this.state.value
    if (
        prevState?.value?.resuscitation !== resuscitation ||
        prevState?.value?.resuscitationDocumentation !==
        resuscitationDocumentation
    ) {
      this.setState({
        formChanged: true
      })
    }
  }

  queueIssues (data) {
    const iq = new IssueQueuer({
      dispatch: this.props.dispatch,
      patientId: this.props.patientId,
      practitionerId: this.props.practitionerId,
      encounterId: this.props.encounterId
    })
    iq.queueIssues({
      mapping: Choices.resuscitation,
      currentForm: data
    })
  }

  handleCancel () {
    this.props.dispatch(
      Actions.getAssessment(
        this.props.patientId,
        RESUSCITATION_CATEGORY,
        ResuscitationQuestionnaire
      )
    )
  }

  handleSubmit () {
    const { currentUser, patientId, encounterId } = this.props
    const data = this.state.value
    this.queueIssues(data)
    this.props.dispatch(
      Actions.createAssessment(
        data,
        patientId,
        currentUser.id,
        RESUSCITATION_CATEGORY,
        encounterId,
        ResuscitationQuestionnaire
      )
    )
    this.setState({ formChanged: false })
  }

  render () {
    return (
      <form
        onSubmit={this.handleSubmit}
        style={style.form}
      >
        <h2>Resuscitation Choice</h2>
        <QuestionRadioButtonInput
          {...ResuscitationQuestionnaire.resuscitation}
          radioButtons={YesNoRadioOptions}
        />

        <QuestionRadioButtonInput
          {...ResuscitationQuestionnaire.resuscitationDocumentation}
          radioButtons={YesNoRadioOptions}
        />

        <div
          className='row margin-top end-xs'
          style={style.marg}
        >
          <div className='col-xs-offset-8 col-xs-4'>
            <CancelButton onClick={this.handleCancel} />
            <SaveButton onClick={this.handleSubmit} />
          </div>
        </div>
      </form>
    )
  }
}

const mapStateToProps = redux => ({
  currentUser: redux.users.current_user,
  practitionerId: redux.auth.profile.sub,
  patientId: redux.globalVars.params.id,
    encounterId: redux.encounter?.encounter?.document?.context_id
})

export default connect(mapStateToProps)(ResuscitationChoiceForm)
